module.exports = "/packs/media/modules/welcome/welcome/faq/assets/adjustments-2d0ad4626e08d1ab0ec14dd38a356299.xlsx";